export default __webpack_public_path__ + "static/media/cube.0ddaa43d.obj";